import React from "react";
import { Typography, Box, Button, Dialog, DialogContent } from "@mui/material";

const SavedCouponPopUp = (props) => {
  const { showPopUp, onCancelClick, onDeleteClick } = props;
  return (
    <>
      <Dialog open={showPopUp} className="app-dialog">
        <DialogContent sx={{ padding: "40px" }}>
          <Box sx={{ textAlign: "center" }}>
            <Box sx={{ textAlign: "center" }}>
              <Box mt={2} mb={4}>
                <Typography variant="text3" sx={{ fontSize: "18px" }}>
                  This coupon is already in your <br />
                  My Coupons list.
                </Typography>
              </Box>
              <Box mb={4}>
                <Typography variant="text3" sx={{ fontSize: "16px", color: "#607277" }}>
                  Deleting this coupon also deletes daily <br /> dose and refill savings reminders.
                </Typography>
              </Box>
              <Box mb={6}>
                <Typography variant="text3" sx={{ fontSize: "20px" }}>
                  Delete this coupon?
                </Typography>
              </Box>

              <Box mb={4}>
                <Button
                  variant="large"
                  sx={{ minWidth: { xs: "150px", sm: "100%", md: undefined } }}
                  onClick={onDeleteClick}
                >
                  DELETE
                </Button>
              </Box>
              <Box mt={2} mx="auto" sx={{ width: "100%" }}>
                <Button
                  variant="text"
                  sx={{ minWidth: { xs: "150px", sm: "100%", md: undefined } }}
                  onClick={onCancelClick}
                >
                  CANCEL
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SavedCouponPopUp;
